import { unhandledRequest } from '../request';

export type Translation = {
  language: string;
  title: string;
};

export type WorkType = {
  id: number;
  translations: Translation[];
  numJobs: number;
  enabled: boolean;
};

type WorkTypeData = Omit<WorkType, 'id' | 'numJobs'>;

export async function loadWorkTypes() {
  const response = await unhandledRequest.get<WorkType[]>({
    url: `v1/worktypes/`,
  });
  return response.data;
}

export async function createWorkType(data: WorkTypeData) {
  const response = await unhandledRequest.post<WorkType>({
    url: `v1/worktypes/`,
    data,
  });
  return response.data;
}

export async function updateWorkType(id: number, data: WorkTypeData) {
  const response = await unhandledRequest.patch<WorkType>({
    url: `v1/worktypes/${id}/`,
    data,
  });
  return response.data;
}

export async function deleteWorkType(id: number) {
  const response = await unhandledRequest.delete({
    url: `v1/worktypes/${id}/`,
  });
  return response.data;
}
